import { render, staticRenderFns } from "./ChartComponent.vue?vue&type=template&id=c3cd6052&scoped=true&"
import script from "./ChartComponent.vue?vue&type=script&lang=js&"
export * from "./ChartComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cd6052",
  null
  
)

export default component.exports